<template>
	<v-card outlined class="mt-2">
		<v-card-title	
			v-text="'user permission settings'" 					
			class="justify-center text-uppercase caption pa-1 light-blue darken-2"
		>					
		</v-card-title>
		<v-card-text>
			<!--<v-card outlined class=" my-2">
				<v-card-title
					class="caption pa-1 light-blue darken-4"
				>
					<v-spacer></v-spacer>
					<span v-text="'Roles permission'"></span>
					<v-spacer></v-spacer>
					<v-tooltip top>
						<template v-slot:activator="{ on }">								
							<v-icon 
								
								v-text="'mdi-information'"
								v-on="on"
								class="mr-2"
							></v-icon>
						</template>
						<template v-for="item_info_crud  of defaults_cruds">
							<strong> {{ item_info_crud.word }} </strong>
							<span>	{{ item_info_crud.text }} </span> <br>				
							
						</template>
						
					</v-tooltip>
					<v-btn
						small
						dark
						@click="show_role.show=!show_role.show"
					>
						<v-icon
							small
							:color="show_role.show ?  'error' : 'primary' "
							v-text="show_role.show ? 'mdi-close' : 'mdi-plus' "
						>								
						</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-data-table
						dense
						outlined
						:headers="header_user"
						:items="list_roles"

					>
						<template v-slot:item.actions="{ item }">
							<v-btn
								x-small
								@click="edit(item)"
							>
								<v-icon
									x-small
									color="primary"
								>
									mdi-pencil
								</v-icon>
							</v-btn>
							<v-btn
								x-small
								@click="del(item)"
							>
								<v-icon
									x-small
									color="error"
								>
									mdi-delete
								</v-icon>
							</v-btn>
						</template>
						<template v-slot:item.permission="{ item }">
							<template v-for="item_word of item.permission">
								{{ item_word }}
							</template>
						</template>
					</v-data-table>

				</v-card-text>
				<v-dialog v-model="show_role.show" width="450">
					<v-card outlined>
						<v-card-title
							v-text="show_role.show"
							class="justify-center body-1 primary pa-1"
						>
						</v-card-title>
						<v-card-text>
						<!- - 	<input_fields
							 	:input_info="info_to_input"
								@info_from_input=""
							></input_fields> -->
							<!-- <v-row>
								<template v-for="(item_modal, index_modal) of show_role.info">
									<v-col
										md="12"
										:key="index_modal"
									>
										<v-text-field
											:label="item_modal"
										>
										</v-text-field>
									</v-col>
								</template>
							</v-row> - ->
						</v-card-text>
					</v-card>
				</v-dialog>
			</v-card>-->
			<!-- Permission -->
			<v-card	outlined>
				<v-card-title
					class="justify-center caption pa-1 secondary"
				>
					<span 
						class="white--text" 
						v-text="'Permissions'"
					></span>
				</v-card-title>
				<v-card-text>
					<input_table
						:info_table="info_to_table"
						:list_table="list_permissions"
						@pagination_table="info_to_table.options=$event"
					></input_table>
				</v-card-text>
			</v-card>
		<!-- Views  permissions -->
		<v-card outlined			
		>
			<v-card-title 
				class="justify-center caption pa-1 secondary"
			>
			<span 
				class="white--text" 
				v-text="'View permissions'"
			></span>
			</v-card-title>
			<v-card-text>
				<input_table
					:info_table="info_to_table_views"
					:list_table="list_view_permission"
					@pagination_table="info_to_table_views.options=$event"
				></input_table>
			</v-card-text>
		</v-card>
		</v-card-text>
	</v-card>
</template>
<script>
import axios from 'axios'
import input_fields from '@/components/info/input_fields.vue'
import input_table from '@/components/info/input_table.vue'
	export default{
		name: 'user_permissions',
		components:{
			input_fields,
			input_table
		}, // components
		props: [ 'info_component' ],
		data: (vm) => ({
			header_user: [
					{ text: 'ID', value: 'id', align: 'center' },
					{ text: 'Role name', value: 'name', align: 'center' },
					{ text: 'Permissions', value: 'permission', align: 'center' },
					{ text: vm.$ml.get('date'), value: 'createdAt', align: 'center' },
					{ text: vm.$ml.get('actions'), value: 'actions', align: 'center' }
				], // header_user
			list_roles: [],
			list_permissions: [],
			show_role: 
				{ 
					show: false,
					title: 'New Role',
					info:[
						{
							title: 'name',
							text:  'name',
							type: 'string'
						},
					] 
				}, // show_role
			defaults_cruds:[
				{ word: 'Word', text: 'Permission'},
				{ word: 'C', text: 'Create'},
				{ word: 'R', text: 'Read / Access to view module'},
				{ word: 'U', text: 'Update'},
				{ word: 'D', text: 'Delete'},

			], // defaults_cruds
			info_to_input: null,
			info_to_table: null,
			header_permission: [
				{ text: vm.$ml.get('name'), value: 'role.name', align: '' },
				{ text: 'Create', value: 'can_add', align: '' },
				{ text: 'View', value: 'can_view', align: '' },
				{ text: 'Edit', value: 'can_edit', align: '' },
				{ text: 'Delete', value: 'can_delete', align: '' },
				{ text: vm.$ml.get('date'), value: 'createdAt', align: '' },
			], // header_permission			
			info_to_table_views: null,
			header_permission_view: [
				{ text: "Name view", value: 'name_view', align: '' },
				// { text: "Name path", value: 'name_path', align: '' },
				{ text: "User role permission", value: 'user_roles_permission', align: '' },
				
			], // header permission view
			list_view_permission: [
				{ 
					name_view: 'Dashboard', 
					name_path: 'dashboard', 
					user_roles_permission: '1 , 2 , 3' 
				},
				// { name_view: 'LPR', name_path: '', user_roles_permission: '1 , 2' },
				{ 
					name_view: 'Dashboard LPR', 
					name_path: 'dashboard_lpr', 
					user_roles_permission: '1 , 2, 3' 
				},
				{ 
					name_view: 'Reports LPR', 
					name_path: 'reports', 
					user_roles_permission: '1, 2, 3' 
				},
				{ 
					name_view: 'NVR', 
					name_path: 'nvr', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Blacklist', 
					name_path: 'dialog_settings', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Settings', 
					name_path: 'settings', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'User', 
					name_path: 'user', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Host', 
					name_path: 'host_configuration', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Integration', 
					name_path: 'integration_cloud', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Category', 
					name_path: 'alert_sounds_settings', 
					user_roles_permission: '1, 2' 
				},
				{ 
					name_view: 'Face', 
					name_path: 'face', 
					user_roles_permission: '1, 2, 3' 
				},
				{ 
					name_view: 'Dashboard SZ', 
					name_path: 'safe_zone', 
					user_roles_permission: '1, 2, 3' 
				},
				{ 
					name_view: 'Contacts SZ', 
					name_path: 'sz_contacts', 
					user_roles_permission: '1, 2' 
				},
				{
					name_view: 'Host SZ',
					name_path: 'sz_settings',
					user_roles_permission: '1,2'
				},
			], // list_view_permission
		}), // data
		created(){
			// this.list_permissions=this.info_component;
			this.info_to_table={
				headers: this.header_permission,
				options: { itemsPerPage: 30 },
				total: 1,
			}
			this.info_to_table_views={
				headers: this.header_permission_view,
				options: {itemsPerPage: 30 },
				total: 14,
			}


		}, // created
		methods:{
			get_list_roles(){
				let api = this.$URL + '/api/v1/role/';
				axios.defaults.withCredentials=true;
				axios.get(api).then( res => {
					let items=res.data;
					let list_render=items.rows;
					for(let i = 0; i < list_render.length; i++){
						if (list_render[i].id==1) {
							list_render[i].permission='CRUD';
						}else if(list_render[i].id==2){
							list_render[i].permission='CRU';
						}else if(list_render[i].id==3){
							list_render[i].permission='R';
						}
					}
					this.list_roles=list_render;
				}).catch( er =>{
					console.log(er, 'Error roles');
				});
			}, // get list roles

			get_list_permissions(){
				let api = this.$URL + '/api/v1/permission/';
				axios.defaults.withCredentials=true;
				axios.get(api).then( res => {
					let items=res.data;
					let list_render=items.rows;
					/*for(let i = 0; i < list_render.length; i++){
						if (list_render[i].id==1) {
							list_render[i].permission='CRUD';
						}else if(list_render[i].id==2){
							list_render[i].permission='CRU';
						}else if(list_render[i].id==3){
							list_render[i].permission='R';
						}
					}*/
					console.log(list_render, items,  'list permissions')
					this.list_permissions=list_render;					
					this.info_to_table.total=items.count;

				}).catch( er =>{
					console.log(er, 'Error roles');
				});
			}, // get list permissions
		}, // methods
		mounted(){
			this.get_list_roles();
			this.get_list_permissions();
		}, // mounted
	};
</script>